// redux/actions/conciliacion_status/types.js
export const FETCH_CONCILIACION_STATUS_SUCCESS = "FETCH_CONCILIACION_STATUS_SUCCESS";
export const FETCH_CONCILIACION_STATUS_FAILURE = "FETCH_CONCILIACION_STATUS_FAILURE";
